"use strict";

const $ = document.querySelector.bind(document);
const $$ = document.querySelectorAll.bind(document)
// const rdc = {
//   mode: 'same-origin',
//   credentials: 'same-origin',
//   headers: {
//     'X-Requested-With': 'XMLHttpRequest',
//     'Content-Type': 'application/json'
//   }
// }
// let parser = new DOMParser();
// const c = new Map();
// const productRecommendationsSection = document.querySelector('.product-recommendations');
var BlsSubActionProduct = (function() {
  return {
      init: function() {
          this.handleInitQuickviewAction();
          this.handleActionWishlist();
          this.handleInitWishlist();
          this.handleActionCompare();
          this.handleInitCompare();
      },

      handleInitQuickviewAction: function() {
        const _this = this
        document.querySelectorAll('.bls__product-quickview').forEach(e => {
          e.addEventListener('click', () => {
            e.classList.add('btn-loading')
            const exist_load = e.querySelectorAll('span.loader-icon')
            if (exist_load.length === 0) {
              const exist_loading = e.querySelectorAll('div.loader-icon')
              if (exist_loading.length === 0 ) {
                const spanLoading = document.createElement('div')
                spanLoading.classList.add('loader-icon')
                e.appendChild(spanLoading)
              }
            }
            const productTarget = e.closest('.bls__product-item')
            _this.handleFetchDataQuickView(e, productTarget.dataset.productHandle);
          })
        })
      },

      handleFetchDataQuickView : function (e, handle) {
        if (handle) {
          var productAjaxURL = "/products/"+ handle +"/?section_id=product-quickview";
          fetch(productAjaxURL)
          .then(response => response.text())
          .then((responseText) => {
            const html = parser.parseFromString(responseText, 'text/html');
            html.querySelectorAll('#shopify-section-product-quickview').forEach(el => {
              var quickviewBox = EasyDialogBox.create(e, 'dlg dlg-disable-heading dlg-disable-footer dlg-disable-drag', '', el.innerHTML);
              quickviewBox.onClose = quickviewBox.destroy;
              quickviewBox.show();
              BlsColorSwatchesShopify.init();
              BlsReloadSpr.init();
              Shopify.eventFlashSold('dlg');
              Shopify.eventCountDownTimer('dlg');
              Shopify.swiperSlideQickview();
              BlsSubActionProductPreLoad.handleActionQuickview();
              BlsLazyloadImg.init();
              Shopify.PaymentButton.init();
            })
          }).catch((e) => {
            console.error(e);
          })
          .finally(() => {
              e.classList.remove('btn-loading')
              e.querySelectorAll('.loader-icon').forEach(el => {
                  el.remove()
              })
          });
        }
      },

      handleInitWishlist: function () {
        const wishlist_items = JSON.parse(localStorage.getItem('bls__wishlist-items'))
        const wishlist_icon = document.querySelectorAll('.bls__product-wishlist')
        wishlist_icon.forEach(e => {
          const {
            proAddWishlist,
            proRemoveWishlist
          } = e?.dataset
          const tooltip_wishlist = e.querySelector('.bls_tooltip-content')
          const productHandle = e.dataset.productHandle
          if (wishlist_items !== null) {
            let index = wishlist_items.indexOf(productHandle)
            if (index !== -1) {
              e.querySelector('.bls__product-icon').classList.add('active')
              tooltip_wishlist.innerText = proRemoveWishlist
            }else{
              e.querySelector('.bls__product-icon').classList.remove('active')
              tooltip_wishlist.innerText = proAddWishlist
            }
          }
          BlsWishlistHeader.init()
        })
      },

      handleActionWishlist: function() {
          const _this = this
          const btnWishlist = document.querySelectorAll('.bls__product-wishlist-js')
          const is_page_wishlist = document.querySelector('.bls__wishlist-page-section')
          if (btnWishlist.length > 0) {
            btnWishlist.forEach(e => {
              e.addEventListener('click', function () {
                console.log(123)
                const wishlist_items = JSON.parse(localStorage.getItem('bls__wishlist-items'))
                const preload = e.closest('.bls__product-preload-js')
                if (!preload) {
                  const productHandle = e.dataset.productHandle
                  const arr_items = [];
                  if (wishlist_items === null) {
                      arr_items.push(productHandle)
                      localStorage.setItem('bls__wishlist-items', JSON.stringify(arr_items))
                      if (is_page_wishlist) {
                        BlsWishlistPageShopify.init();
                      }
                  }else{
                    let index = wishlist_items.indexOf(productHandle)
                    arr_items.push(...wishlist_items)
                    if (index === -1) {
                        arr_items.push(productHandle)
                        localStorage.setItem('bls__wishlist-items', JSON.stringify(arr_items))
                        if (is_page_wishlist) {
                          BlsWishlistPageShopify.init();
                        }
                    } else if (index > -1) {
                        arr_items.splice(index, 1);
                        localStorage.setItem('bls__wishlist-items', JSON.stringify(arr_items))
                        if (is_page_wishlist) {
                          const div_no_product = is_page_wishlist.querySelector('.bls__wishlist-no-product-js')
                          const item_remove = document.querySelector('.bls__wishlist-list[data-product-handle="'+ productHandle +'"]');
                          if (item_remove) {
                            item_remove.remove()
                          }
                          if (wishlist_items.length <= 1) {
                            div_no_product.classList.remove('d-none')
                          }
                        }
                    }
                  }

                  _this.handleInitWishlist();
                }
              })
            })
        }
      },

      handleInitCompare: function () {
        const compare_items = JSON.parse(localStorage.getItem('bls__compare-items'))
        const compare_icon = document.querySelectorAll('.bls__product-compare')
        compare_icon.forEach(e => {
          const {
            proAddCompare,
            proRemoveCompare
          } = e?.dataset
          const tooltip_compare = e.querySelector('.bls_tooltip-content')
          const productHandle = e.dataset.productHandle
          if (compare_items !== null) {
            let index = compare_items.indexOf(productHandle)
            if (index !== -1) {
              e.querySelector('.bls__product-icon').classList.add('active')
              tooltip_compare.innerText = proRemoveCompare
            }else{
              e.querySelector('.bls__product-icon').classList.remove('active')
              tooltip_compare.innerText = proAddCompare
            }
          }
        })
      },

      handleActionCompare: function() {
          const _this = this
          const btnCompare = document.querySelectorAll('.bls__product-compare-js')
          const is_page_compare = document.querySelector('.bls__compare-page-section')
          if (btnCompare.length > 0) {
            btnCompare.forEach(e => {
              e.addEventListener('click', function () {
                const compare_items = JSON.parse(localStorage.getItem('bls__compare-items'))
                const preload = e.closest('.bls__product-preload-js')
                if (!preload) {
                  const productHandle = e.dataset.productHandle
                  const arr_items = [];
                  if (compare_items === null) {
                      arr_items.push(productHandle)
                      localStorage.setItem('bls__compare-items', JSON.stringify(arr_items))
                      if (is_page_compare) {
                        BlsComparePageShopify.init();
                      }
                  }else{
                      let index = compare_items.indexOf(productHandle)
                      arr_items.push(...compare_items)
                      if (index === -1) {
                          arr_items.push(productHandle)
                          localStorage.setItem('bls__compare-items', JSON.stringify(arr_items))
                          if (is_page_compare) {
                            BlsComparePageShopify.init();
                          }
                      } else if (index > -1) {
                          arr_items.splice(index, 1);
                          localStorage.setItem('bls__compare-items', JSON.stringify(arr_items))
                          if (is_page_compare) {
                            const div_no_product = is_page_compare.querySelector('.bls__compare-no-product-js')
                            const item_remove = document.querySelectorAll('.bls__compare-value[data-product-handle="'+ productHandle +'"]');
                            if (item_remove.length !== 0) {
                              item_remove.forEach(i => {
                                i.remove()
                              })
                            }
    
                            if (compare_items.length <= 1) {
                              div_no_product.classList.remove('d-none')
                              const attr_remove = document.querySelector('.bls__compare-table')
                              if (attr_remove) {
                                attr_remove.classList.add('d-none')
                              }
                            }
                          }
                      }
                  }
                  _this.handleInitCompare();
                }
              })
            })
        }
      },
    }
})();
BlsSubActionProduct.init()
var BlsReloadEvents = (function() {
    return {
        init: function() {
            this.setupEventListeners();
        },

      setupEventListeners: function() {
          document.addEventListener("shopify:section:load", function (event) {
            var id = event.detail.sectionId;

            var section = event.target.querySelector('[' + 'data-id' + '="' + id + '"]');

            if (section != undefined) {
              const {
                type
              } = section?.dataset;
              switch (type) {
                case 'instagram':
                  BlsInstagramShopify.init()
                  break;
                case 'product_grid':
                  BlsProductGridEvents.init()
                  BlsProductTabEvents.init()
                  BlsColorSwatchesShopify.init();
                  break;
                case 'product_carousel':
                  BlsProductGridEvents.init()
                  BlsProductTabEvents.init()
                  BlsColorSwatchesShopify.init();
                  break;
                case 'recently_viewed_products':
                  BlsRVProductsShopify.init()
                  break;
                case 'product_recommendations':
                  BlsProductRecommendsEvents.init()
                  break;
                case 'product_single':
                  BlsColorSwatchesShopify.init();
                  break;
                case 'product_deal':
                  BlsColorSwatchesShopify.init();
                  BlsCountdownTimer.init()
                  break;
                default:
                  break;
              }
            }
          });
      }
  }
})();
BlsReloadEvents.init();



var BlsInstagramShopify = (function() {
  return {

      init: function() {
          this.loadInstagram();
      },

      loadInstagram: function() {
        const ig_class = $$('.bls__instagram-api')
        ig_class.forEach(e => {
          if (e != undefined) {
            const {
              accessToken,
              images,
              igType
            } = e?.dataset;
            if (accessToken) {
              this.initInstagram(e, accessToken, images, igType);
            } else {
              console.warn('Access Token is invalid!');
            }
          }
        })
      },

      initInstagram: async function(nodeElement, at, num_img, igType) {
        const _this = this
        let i = num_img !== undefined ? num_img : 4;
        const resp = await this.fetchCache(`https://graph.instagram.com/me/media?fields=caption,id,media_type,media_url,permalink,thumbnail_url,timestamp,username&access_token=${at}`, {
            cache: 'force-cache'
        });
        if (!resp) return;

        if (resp.error) {
            return console.error('Instagram error: ', resp.error?.message);
        }
        if (igType === 'carousel') {
          _this.initCarousel(resp.data, nodeElement, i)
        } else {
          _this.initGrid(resp.data, nodeElement, i)
        }
      },

      fetchCache: function(u, fetchOption) {
        let cf = fetchOption !== undefined ? fetchOption : rdc;
        return new Promise((resolve, reject) => {
          if (c.get(u)) {
            return resolve(c.get(u));
          }
          fetch(u, cf).then(res => {
              if (res.ok) {
                  const j = res.json();
                  resolve(j);
                  c.set(u, j);
                  return j;
              } else {
                  reject(res);
              }
              }).catch(reject);
        });
      },

      initCarousel: function(images, nodeElement, i) {
        images.filter(d => d.media_type === 'IMAGE' || d.media_type === 'CAROUSEL_ALBUM').slice(0, i).forEach(image => {
        var node = document.createElement('div')
        node.classList.add('swiper-slide')
        var responsiveImageNode = document.createElement('div')
        var node_ig_item = document.createElement('div')
        node_ig_item.classList.add('bls__instagram-item')
        var imgUrl = document.createElement('a')
        var ig_logo = document.createElement('span')
        ig_logo.classList.add('bls__instagram-icon')
        responsiveImageNode.classList.add('bls__responsive-image')
        responsiveImageNode.classList.add('bls_instagram-image')
        responsiveImageNode.classList.add('bls-image-js')
        responsiveImageNode.setAttribute('style','--aspect-ratio:1/1')
        responsiveImageNode.innerHTML += `<img src="${image.media_url}" srcset="${image.media_url}&width=165 165w,${image.media_url}&width=330 330w,${image.media_url}&width=535 535w,${image.media_url}&width=750 750w,${image.media_url}&width=1000 1000w,${image.media_url}&width=1500 1500w,${image.media_url}&width=3000 3000w" sizes="(min-width: 1260px) 282px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" loading="lazy" alt="instagram">`
        imgUrl.setAttribute('href',image.permalink)
        imgUrl.appendChild(responsiveImageNode)
        imgUrl.appendChild(ig_logo)
        node_ig_item.appendChild(imgUrl)
        node.appendChild(node_ig_item)
        nodeElement.querySelector('.swiper-wrapper').appendChild(node);});
        BlsLazyloadImg.init();
      },

      initGrid: function(images, nodeElement, limits) {
        const _this = this
        const gridNode = nodeElement.querySelector('.bls__instagram-grid')
        if (gridNode) {
          const {
            spacing,
          } = gridNode?.dataset;
          nodeElement.setAttribute('style','--bs-gutter-x:'+spacing+'px')
          var items = Number(limits);
          images.filter(d => d.media_type === 'IMAGE' || d.media_type === 'CAROUSEL_ALBUM').slice(0, items).forEach(image => {
            var node = document.createElement('div')
            node.classList.add('bls__instagram-item')
            var imgUrl = document.createElement('a')
            var ig_logo = document.createElement('span')
            ig_logo.classList.add('bls__instagram-icon')
            var nodeChild = document.createElement('div')
            nodeChild.classList.add('bls__responsive-image')
            nodeChild.classList.add('bls-image-js')
            nodeChild.setAttribute('style','--aspect-ratio: 1/1')
            nodeChild.classList.add('bls_instagram-image')
            nodeChild.innerHTML += `<img src="${image.media_url}" srcset="${image.media_url}&width=165 165w,${image.media_url}&width=330 330w,${image.media_url}&width=535 535w,${image.media_url}&width=750 750w,${image.media_url}&width=1000 1000w,${image.media_url}&width=1500 1500w,${image.media_url}&width=3000 3000w" sizes="(min-width: 1260px) 282px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)" loading="lazy" alt="instagram">`
            imgUrl.setAttribute('href',image.permalink)
            imgUrl.appendChild(nodeChild)
            imgUrl.appendChild(ig_logo)
            node.appendChild(imgUrl)
            gridNode.querySelector('.row').appendChild(node);
            BlsLazyloadImg.init();
          });
        }
      },
  }
})();
BlsInstagramShopify.init();

var BlsProductGridEvents = (function() {
  return {

      init: function() {
          this.setupEventListeners();
      },

      setupEventListeners: function() {
        const _this = this;
          $$('.bls__btn-load-more').forEach(el=>{
            el.addEventListener('click', function (){
              const sectionId = this.closest('.bls__grid').dataset.id
              _this.loadButtonLoadMore(sectionId)
            })
          })
      },

      loadButtonLoadMore: function(sectionId) {
        const defClass = $('.bls__load-more_wrap-'+sectionId)
        if (defClass != undefined) {
          const {
            nextUrl,
            currentPage,
            totalPages
          } = defClass?.dataset;
          this.loadMore(defClass,sectionId,nextUrl,currentPage,totalPages);
        }
      },

      loadMore: function(defClass,sectionId,nextUrl,currentPage,totalPages) {
        const grid = $('#bls__product-grid-'+sectionId)
        if (grid != undefined) {
          const {
            id,
            r,
            d,
            to
          } = grid?.dataset;
          const loadMoreBtn = defClass.querySelector('[type="button"]');
          loadMoreBtn.classList.add('btn-loading')
          let nextPage = parseInt(currentPage) + 1
          fetch(`${nextUrl}?page=${nextPage}&section_id=${id}`)
            .then(response => response.text())
            .then((responseText) => {
                const productNodes = parser.parseFromString(responseText, 'text/html');
                const productNodesHtml = productNodes.querySelectorAll(`#bls__product-grid-${sectionId} .bls__product-load`);
                productNodesHtml.forEach(prodNode => document.getElementById(`bls__product-grid-${sectionId}`).appendChild(prodNode));
            }).catch((e) => {
              console.error(e);
            })
            .finally(() => {
              loadMoreBtn.classList.remove('btn-loading');
              if (nextPage == totalPages) {
                defClass.remove();
              } else {
                defClass.setAttribute("data-current-page", nextPage);
              }
              BlsColorSwatchesShopify.init();
              BlsSectionProductAddCart.updateBtnAdd();
              BlsSubActionProduct.init();
              BlsSubActionProductPreLoad.handleActionLm();
              BlsReloadSpr.init();
              BlsLazyloadImg.init();
            });
        }
      },
  }
})();
BlsProductGridEvents.init()

var BlsProductTabEvents = (function() {
  return {
        init: function() {
            this.setupEventListeners();
            this.setupDropdownStyle();
            document.addEventListener("click", this.closeAllSelect);
        },

        setupEventListeners: function(value) {
            $$('.bls__collection-tab').forEach(el=>{
                const tab_item = el.querySelectorAll('.bls__collection-tab-item')
                if (tab_item.length != 0) {
                tab_item.forEach(e => {
                    e.addEventListener('click', function() {
                    if (!this.classList.contains('active')) {
                        el.querySelectorAll('.bls__collection-tab-item').forEach(element => {
                        element.classList.remove('active')
                        })
                        this.classList.add('active')
                        const tabId = this.dataset.id;
                        el.querySelectorAll('.bls__cls-tab').forEach(element => {
                        if (element.id === tabId) {
                            if (!element.classList.contains('active')) {
                            el.querySelectorAll('.bls__cls-tab').forEach(elm => {
                                elm.classList.remove('active')
                            })
                            element.classList.add('active')
                            }
                        }
                        })
                    }
                    })
                })
                } else {
                const tabId = value;
                el.querySelectorAll('.bls__cls-tab').forEach(element => {
                    if (element.id === tabId) {
                    if (!element.classList.contains('active')) {
                        el.querySelectorAll('.bls__cls-tab').forEach(elm => {
                        elm.classList.remove('active')
                        })
                        element.classList.add('active')
                    }
                    }
                })
                }
            })
        },

      setupDropdownStyle: function() {
        const _this = this
        var x, i, j, l, ll, selElmnt, a, b, z, p, o;
        x = document.getElementsByClassName("custom-select");
        l = x.length;
        if (l > 0) {
          for (i = 0; i < l; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            x[i].innerHTML = '';
            x[i].appendChild(selElmnt);
            ll = selElmnt.length;
            a = document.createElement("div");
            a.setAttribute("class", "select-selected flex justify-content-between w-full");
            p = document.createElement("span");
            p.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            a.appendChild(p)
            o = document.createElement("span");
            o.setAttribute("class", "select-arrow");
            o.innerHTML = `<svg fill="currentColor" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path></svg>`
            a.appendChild(o)
            x[i].appendChild(a);
            b = document.createElement("div");
            b.setAttribute("class", "select-items select-hide");
            for (j = 0; j < ll; j++) {
              z = document.createElement("div");
              z.innerHTML = selElmnt.options[j].innerHTML;
              if (selElmnt.options[j].getAttribute('selected')) {
                z.setAttribute("class", "same-as-selected");
              }
              z.addEventListener("click", function(e) {
                  var y, i, k, s, h, sl, yl;
                  s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                  sl = s.length;
                  h = this.parentNode.previousSibling;
                  for (i = 0; i < sl; i++) {
                    if (s.options[i].innerHTML == this.innerHTML) {
                      s.selectedIndex = i;
                      h.childNodes[0].innerHTML = this.innerHTML;
                      y = this.parentNode.getElementsByClassName("same-as-selected");
                      yl = y.length;
                      for (k = 0; k < yl; k++) {
                        y[k].removeAttribute("class");
                      }
                      this.setAttribute("class", "same-as-selected");
                      break;
                    }
                  }
                  s.dispatchEvent(new Event('change'));
                  s.dispatchEvent(new Event('click'));
                  h.click();
              });
              b.appendChild(z);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function(e) {
                e.stopPropagation();
                _this.closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
                _this.setupEventListeners(this.closest('.custom-select').querySelector('.select-data').value);
              });
          }
        }
      },
      closeAllSelect: function(elmnt) {
        var x, y, i, xl, yl, arrNo = [];
        x = document.getElementsByClassName("select-items");
        y = document.getElementsByClassName("select-selected flex justify-content-between w-full");
        xl = x.length;
        yl = y.length;
        for (i = 0; i < yl; i++) {
          if (elmnt == y[i]) {
            arrNo.push(i)
          } else {
            y[i].classList.remove("select-arrow-active");
          }
        }
        for (i = 0; i < xl; i++) {
          if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
          }
        }
      }
  }
})();
BlsProductTabEvents.init()


var BlsColorSwatchesShopify = (function() {
    return {
        init: function() {
            this.initSwatches();
        },

        initSwatches: function() {
            const _this = this;
            const actionSwatchColor = document.querySelectorAll('.bls__product-color-swatches');
            actionSwatchColor.forEach(e => {
                _this.checkSwatches(e);
            });
            const actionSwatch = document.querySelectorAll('.bls__option-swatch-js');
            actionSwatch.forEach(e => {
                const productTarget = e.closest('.bls__product-item');
                if (productTarget) {
                    e.addEventListener("mouseover", () => {
                        _this.listenerColor(e, productTarget)
                    })
                }
            });
        },

        listenerColor: function(e, productTarget) {
            const _this = this
            setTimeout(() => {
            if (!e.classList.contains('active')) {
                const activeSwatches = e.closest('.bls__product-option').querySelectorAll('.bls__option-swatch-js')
                activeSwatches.forEach(el => {
                    el.classList.remove('active');
                })
                e.classList.toggle('active');
                _this.swapProduct(productTarget);
            }
            }, 0);
        },

        updateMasterId(options, variantData) {
            var result = variantData.find((variant) => {
                return !variant.options.map((option, index) => {
                return options[index] === option;
                }).includes(false);
            });
            return result;
        },

        updatePrice(currentVariant, productTarget) {
            if (!currentVariant) return;
            const compare_at_price = currentVariant.compare_at_price;
            const price = currentVariant.price;
            const price_format = Shopify.formatMoney(currentVariant.price, cartStrings.money_format);
            productTarget.querySelector('.price__regular .price').innerHTML = price_format;
            const bls__price = productTarget.querySelector('.bls__price');
            bls__price.classList.remove('price--sold-out', 'price--on-sale');
            bls__price.querySelector('.price__regular .price').classList.remove('special-price');
            if (compare_at_price && compare_at_price > price) {
                const compare_format = Shopify.formatMoney(compare_at_price, cartStrings.money_format)
                bls__price.querySelector('.compare-price').innerHTML = compare_format;
                bls__price.classList.add('price--on-sale');
                bls__price.querySelector('.price__regular .price').classList.add('special-price');
            } else if (!currentVariant.available) {
                bls__price.classList.add('price--sold-out');
            }
        },

        updateMedia(currentVariant, productTarget) {
            if (!currentVariant) return;
            if (!currentVariant.featured_media) return;
            setTimeout(() => {
                productTarget.querySelector('.bls__product-main-img img').removeAttribute('srcset');
                productTarget.querySelector('.bls__product-main-img img').setAttribute('src', currentVariant.featured_media.preview_image.src);
            }, 500);
        },

        renderProductInfo(currentVariant, variantQtyData, productTarget) {
            let qty = 0;
            let percent = 0;
            let sale = false;
            let sold_out = false;
            let pre_order = false;
            const compare_at_price = currentVariant.compare_at_price;
            const price = currentVariant.price;
            variantQtyData.find((variantQty) => {
                if (variantQty.id === currentVariant.id) {
                    qty = variantQty.qty;
                }
            });
            if (compare_at_price && compare_at_price > price) {
                sale = true;
                percent = (compare_at_price - price)/compare_at_price*100;
            }
            if (currentVariant.available && qty < 1) {
                pre_order = true;
            } else if (!currentVariant.available) {
                sold_out = true
            }
            const product_label = productTarget.querySelector('.bls__product-label');
            if (product_label) {
                product_label.remove();
            }
            if (sale || pre_order || sold_out) {
                var element = document.createElement('div');
                element.classList.add('bls__product-label', 'fs-12', 'pointer-events-none', 'absolute');
                productTarget.querySelector('.bls__product-img').appendChild(element);
                const label = productTarget.querySelector('.bls__product-label');
                if (sold_out) {
                    var element_sold_out = document.createElement('div');
                    element_sold_out.classList.add('bls__sold-out-label');
                    element_sold_out.innerText = window.variantStrings.soldOut;
                    label.appendChild(element_sold_out);
                } else {
                    if (sale) {
                        var element_sale = document.createElement('div');
                        element_sale.classList.add('bls__sale-label');
                        element_sale.innerText = -percent.toFixed(0)+'%';
                        label.appendChild(element_sale);
                    } 
                    if (pre_order) {
                        var element_pre_order = document.createElement('div');
                        element_pre_order.classList.add('bls__pre-order-label');
                        element_pre_order.innerText = window.variantStrings.preOrder;
                        label.appendChild(element_pre_order);
                    }
                }
            }

            const productAddCartDiv = productTarget.querySelector('.bls__product-addtocart-js');
            if (productAddCartDiv) {
                const currentVariantId = productAddCartDiv.dataset.productVariantId;
                if (Number(currentVariantId) !== currentVariant.id) {
                    productAddCartDiv.dataset.productVariantId = currentVariant.id;
                }
            }
            this.toggleAddButton(!currentVariant.available, window.variantStrings.soldOut, productTarget, pre_order);
        },

        toggleAddButton(disable = true, text, productTarget, pre_order = false) {
            const productForm = productTarget;
            if (!productForm) return;
            const addButton = productForm.querySelector('.bls__js-addtocart');
            const addButtonText = productTarget.querySelector('.bls__js-addtocart .bls__button-content');
            const addButtonTooltipText = productTarget.querySelector('.bls__js-addtocart .bls_tooltip-content');
            if (!addButton) return;
            if (disable) {
                addButton.setAttribute('disabled', 'disabled');
                if (text){
                    addButtonText.textContent = text;
                    addButtonText.textContent = text;
                } 
            } else {
                addButton.removeAttribute('disabled');
                if (pre_order) {
                    addButtonText.textContent = window.variantStrings.preOrder;
                    addButtonTooltipText.textContent = window.variantStrings.preOrder;
                } else {
                    addButtonText.textContent = window.variantStrings.addToCart;
                    addButtonTooltipText.textContent = window.variantStrings.addToCart;
                }
            }
        },
      
        setUnavailable(productTarget) {
            const addButton = productTarget.querySelector('.bls__js-addtocart');
            const addButtonText = productTarget.querySelector('.bls__js-addtocart .bls__button-content');
            const addButtonTooltipText = productTarget.querySelector('.bls__js-addtocart .bls_tooltip-content');
            if (!addButton) return;
            addButtonText.textContent = window.variantStrings.unavailable;
            addButtonTooltipText.textContent = window.variantStrings.unavailable;
        },

        swapProduct: function(productTarget) {
            const product_swatch_active = productTarget.querySelector('.bls__option-swatch-js.active');
            const position_swatch = product_swatch_active.getAttribute('data-position');
            const variantData = JSON.parse(productTarget.querySelector(".productinfo").textContent);
            const variantQtyData = JSON.parse(productTarget.querySelector(".productVariantsQty").textContent);
            let options = Array.from(productTarget.querySelectorAll('.bls__option-swatch-js.active'), (select) => select.getAttribute('data-value'));      
            variantData.find((variant) => {
                if (options.length == 1) {
                    const variantOptions = {
                        1: variant.option1,
                        2: variant.option2,
                        3: variant.option3
                    };
                    if (variantOptions[position_swatch] === options[0]) {
                        options = variant.options;
                    }
                }
            });
            const currentVariant = this.updateMasterId(options, variantData);
            this.toggleAddButton(true, '', productTarget);
            if (!currentVariant) {
                this.toggleAddButton(true, '', productTarget);
                this.setUnavailable(productTarget);
            } else {
                this.updatePrice(currentVariant, productTarget);
                this.updateMedia(currentVariant, productTarget);
                this.renderProductInfo(currentVariant, variantQtyData, productTarget);
            }
        },

        checkSwatches: function(e) {
            const {
            color,
            image
            } = e?.dataset;
            if (this.checkColor(color)) {
            e.style.backgroundColor  = color;
            }else{
            if (image) {
                e.classList.add = 'bls__'+color.replace(' ','-');
                e.style.backgroundColor  = null;
                e.style.backgroundImage  = "url('"+ image +"')";
                e.style.backgroundSize  = "cover";
                e.style.backgroundRepeat  = "no-repeat";
            }
            }
        },

        checkColor: function(strColor) {
            var s = new Option().style;
            s.color = strColor;
            return s.color == strColor;
        }
    }
})();
BlsColorSwatchesShopify.init();

var BlsRVProductsShopify = (function() {
  return {

        init: function() {
            this.initRVProducts();
        },

        initRVProducts: function() {
            const _this = this;
            var elem = document.querySelector('.bls__product-recently-viewed-section');
            if (elem) {
                var savedProductsArr = JSON.parse(localStorage.getItem("bls__recently-viewed-products"));
                if (savedProductsArr === null) {
                    elem.forEach(e => {
                        e.remove()
                    })
                } else {
                    var savedProductsArrReverse = savedProductsArr.reverse();
                    _this.getStoredProducts(savedProductsArrReverse);
                }
            }
        },
      
        getStoredProducts: function (product) {
            var query = ''
            product.forEach((e, key, product) => {
            
            if (!Object.is(product.length - 1, key)) {
                query += e.id+'%20OR%20id:'
            }
            else{
                query += e.id
            }
            })
            var productAjaxURL = "/search?q=id:" + query+'&section_id=products-recently-viewed';
            fetch(productAjaxURL)
            .then(response => response.text())
            .then(async (responseText) => {
                $$('.bls__product-recently-viewed').forEach(e => {
                const html = parser.parseFromString(responseText, 'text/html');
                html.querySelectorAll('.bls__product-item').forEach(el => {
                    var node = document.createElement('div')
                    node.classList.add('swiper-slide', 'bls__product-preload-js', 'bls__rv-product-js', 'bls__grid');
                    node.appendChild(el)
                    e.querySelector('.swiper-wrapper').appendChild(node);
                })
                })
            }).catch((e) => {
                console.error(e);
            })
            .finally(e => {
                BlsColorSwatchesShopify.init();
                BlsSettingsSwiper.BlsSettingsCarousel();
                BlsSubActionProductPreLoad.handleActionRv();
                BlsSubActionProduct.handleInitWishlist();
                BlsSubActionProduct.handleInitCompare();
                BlsSubActionProduct.handleInitQuickviewAction();
                BlsSectionProductAddCart.updateBtnAdd();
                BlsLazyloadImg.init();
            })
        }
    }
})();
BlsRVProductsShopify.init();

var BlsProductRecommendsEvents = (function() {
  return {

      init: function() {
        if(productRecommendationsSection){
          const observer = new IntersectionObserver(this.handleIntersection, {rootMargin: '0px 0px 1200px 0px'});
          observer.observe(productRecommendationsSection);
        }
      },

      handleIntersection: function(entries, observer) {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);
      
        const url = productRecommendationsSection.dataset.url;
      
        fetch(url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              productRecommendationsSection.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(e => {
            BlsColorSwatchesShopify.init();
            BlsSettingsSwiper.BlsSettingsCarousel();
            BlsSubActionProductPreLoad.handleActionRcm();
            BlsSubActionProduct.handleInitWishlist();
            BlsSubActionProduct.handleInitCompare();
            BlsSubActionProduct.handleInitQuickviewAction();
            BlsSectionProductAddCart.updateBtnAdd();
            BlsLazyloadImg.init();
          })
        
      },
  }
})();
BlsProductRecommendsEvents.init()

var BlsCountdownTimer = (function() {
  return {

      init: function() {
        this.handleCountdown();
        this.eventCountDownTimer();
      },

      eventCountDownTimer: function() {
        const element = document.querySelectorAll('.bls__countdown-timer');

        if (element.length === 0) return;
        element.forEach(e => {
          const day = e.getAttribute('data-days');
          const hrs = e.getAttribute('data-hrs');
          const secs = e.getAttribute('data-secs');
          const mins = e.getAttribute('data-mins');
          const time = e.getAttribute('data-time');
          var countDownDate = new Date(time).getTime();
          var timer = setInterval(function() {
              var now = new Date().getTime();
              var distance = countDownDate - now;
              var days = Math.floor(distance / (1000 * 60 * 60 * 24));
              var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
              var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
              var seconds = Math.floor((distance % (1000 * 60)) / 1000);
              var html = '<span class="countdown-days"><span class="countdown_ti heading-weight">'+days+'</span> <span class="countdown_tx">'+day+'</span></span> '
                  + '<span class="countdown-hours"><span class="countdown_ti heading-weight">'+hours+'</span> <span class="countdown_tx">'+hrs+'</span></span> '
                  + '<span class="countdown-min"><span class="countdown_ti heading-weight">'+minutes+'</span> <span class="countdown_tx">'+mins+'</span></span> '
                  + '<span class="countdown-sec"><span class="countdown_ti heading-weight">'+seconds+'</span> <span class="countdown_tx">'+secs+'</span></span>';
              e.querySelector(".bls__product-countdown").innerHTML = html;
              if (distance < 0) {
                  clearInterval(timer);
              }
          }, 1000);
        })
      },

      handleCountdown: function() {
        var second = 1000, 
        minute = second * 60, 
        hour = minute * 60, 
        day = hour * 24; 
        const timer = $$('.bls__timer')
        timer.forEach(e => {
          const {
            timer
          } = e?.dataset;
          var countDown = new Date(timer).getTime()
          if (countDown) {
            setInterval(function() { 
              var now = new Date().getTime(), 
                distance = countDown - now;
                if (countDown >= now) {
                  e.querySelector('.js-timer-days').innerText 
                  = 
                  Math.floor(distance / (day)) < 10
                  ?
                  ('0' + Math.floor(distance / (day))).slice(-2)
                  :
                  Math.floor(distance / (day)), 
                  e.querySelector('.js-timer-hours').innerText = ('0' + Math.floor((distance % (day)) / (hour))).slice(-2),
                  e.querySelector('.js-timer-minutes').innerText = ('0' + Math.floor((distance % (hour)) / (minute))).slice(-2),
                  e.querySelector('.js-timer-seconds').innerText = ('0' + Math.floor((distance % (minute)) / second)).slice(-2)
                }
              }, second) 
          }
        })
      },
    }
})();
BlsCountdownTimer.init()

var BlsSectionProductAddCart = (function(){
    const miniCart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    return{
        init: function() {
            this.initBtnAdd();
        },

        updateBtnAdd: function() {
            const btnAdd = $$('.bls__js-addtocart');
            btnAdd.forEach(event => {
                event.removeEventListener('click', (e) => {
                    e.preventDefault();
                    const target = e.currentTarget;
                    this.actionAddToCart(target);
                }, false);
                event.addEventListener('click', (e) => {
                    e.preventDefault();
                    const target = e.currentTarget;
                    this.actionAddToCart(target);
                }, false);
            })
        },

        initBtnAdd: function () {
            const btnAdd = $$('.bls__js-addtocart');
            btnAdd.forEach(event => {
                event.addEventListener('click', (e) => {
                    e.preventDefault();
                    const target = e.currentTarget;
                    this.actionAddToCart(target);
                }, false);
            })
        },

        updateMasterId(options, variantData) {
            var result = variantData.find((variant) => {
                return !variant.options.map((option, index) => {
                return options[index] === option;
                }).includes(false);
            });
            return result;
        },

        actionAddToCart: function(e) {
            const _this = this
            e.classList.add('btn-loading');
            const productTarget = e.closest('.bls__product-item');
            const exist_load = e.querySelectorAll('span.loader-icon');
            if (exist_load.length === 0) {
                const exist_loading = e.querySelectorAll('div.loader-icon');
                if (exist_loading.length === 0 ) {
                    const spanLoading = document.createElement('div');
                    spanLoading.classList.add('loader-icon');
                    e.appendChild(spanLoading);
                }
            }
            const qty_input = productTarget.querySelector('.bls__product-qty-js');
            var qty = 1;
            if (qty_input && qty_input.value > 1) {
                qty = qty_input.value;
            }
            const p = productTarget.querySelector('.bls__product-addtocart-js');
            const prodVariantId = p.dataset.productVariantId;
            const sectionMiniCart = miniCart.getSectionsToRender().map((section) => section.id);
            if (productTarget.querySelector(".productinfo")) {
                const variantData = JSON.parse(productTarget.querySelector(".productinfo").textContent);
                let options = Array.from(productTarget.querySelectorAll('.bls__option-swatch-js.active'), (select) => select.getAttribute('data-value'));      
                const currentVariant = this.updateMasterId(options, variantData);
                if (!currentVariant) {
                    _this.selectOption(productTarget, e);
                    return;
                }
            }
            _this.fetchAddCart(prodVariantId, qty, sectionMiniCart, e);
        },

        selectOption: function(productTarget, e) {
            const productHandle = productTarget.dataset.productHandle
            var productAjaxURL = "/products/"+ productHandle +"/?section_id=product-quickview";
            fetch(productAjaxURL)
                .then(response => response.text())
                .then((responseText) => {
                    const html = parser.parseFromString(responseText, 'text/html');
                    html.querySelectorAll('#shopify-section-product-quickview').forEach(el => {
                        var quickviewBox = EasyDialogBox.create('dlg-product-quickview', 'dlg dlg-disable-heading dlg-disable-footer dlg-disable-drag', '', el.innerHTML);
                        quickviewBox.onClose = quickviewBox.destroy;
                        quickviewBox.show();
                    })
                }).catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    e.classList.remove('btn-loading');
                    e.querySelectorAll('.loader-icon').forEach(el => {
                        el.remove();
                    });
                    BlsColorSwatchesShopify.init();
                    Shopify.swiperSlideQickview();
                    BlsSubActionProductPreLoad.handleActionQuickview();
                    Shopify.eventFlashSold('dlg');
                    Shopify.eventCountDownTimer('dlg');
                    BlsReloadSpr.init();
                    Shopify.PaymentButton.init();
                    BlsLazyloadImg.init();
                });
        },

        fetchAddCart : function (variantId, quantity, properties, e) {
            fetch(`${routes.cart_add_url}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify({
                    id: Number(variantId),
                    quantity: Number(quantity),
                    sections: properties
                })
            })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                fetch('/cart.json')
                    .then( res => res.json())
                    .then(cart => {
                        document.querySelectorAll(".cart-count").forEach(el => {
                            el.innerHTML = cart.item_count;
                        })
                    })
                    .catch((error) => {
                        throw error;
                });
                const parsedState = JSON.parse(state);
                miniCart.getSectionsToRender().forEach((section => {
                    const elementToReplace = document.getElementById(section.id);
                    const html = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
                    elementToReplace.innerHTML = html.querySelector('#form-mini-cart').innerHTML;
                    const cart_threshold = document.querySelector('.bls__cart-thres-js');
                    if ( cart_threshold ) {
                        cart_threshold.querySelector('.bls__cart-thres').innerHTML = html.querySelector('.bls__cart-thres').innerHTML;
                        setTimeout(function() {
                            cart_threshold.querySelector('.percent_shipping_bar').setAttribute('style', html.querySelector('.percent_shipping_bar').getAttribute('style'));
                        }, 500);
                    }
                    const countdown = miniCart.querySelector('.cart-countdown-time');
                    const html_countdown = html.querySelector('.cart-countdown-time');
                    if (countdown && html_countdown) {
                        countdown.innerHTML = html_countdown.innerHTML;
                        miniCart.countdownTimer();
                    }
                }));
                miniCart.cartAction();
            })
            .catch((e) => {
                throw e;
            })
            .finally(() => {
                e.classList.remove('btn-loading');
                e.querySelectorAll('.loader-icon').forEach(el => {
                    el.remove();
                });
                if (miniCart && miniCart.classList.contains('is-empty')) miniCart.classList.remove('is-empty');
                miniCart.open();
                BlsLazyloadImg.init();
            });
        }
    }
})();
BlsSectionProductAddCart.init();


var BlsReloadSpr = (function() {
  return {
    init: function () {
        window.SPR?.loadBadges();
    }
  }
})();

// var Blscpc = (function() {
//   return {
//     init: function () {
//       const shop = window.location.hostname.replace(/\./g,'-');
//       if (!$('#'+"bls__"+shop)) {
//         const a = document.createElement("DIV");
//         const n = document.createElement("DIV");
//         const b = document.createElement("h3");
//         const c = document.createElement("p");
//         const step2p = document.createElement("p");
//         const step3p = document.createElement("p");
//         const d = document.createElement("h5");
//         const e = document.createElement("h5");
//         const f = document.createElement("h5");
//         const pca = document.createElement("a");
//         const t = document.createTextNode("Welcome to Uminio latest version 1.0 🎉 ");
//         const s = document.createTextNode("Follow these simple steps to use Umino theme:");
//         const q = document.createTextNode("Step 1: Install Blueskytechco - our FREE app");
//         const p = document.createTextNode("Step 2: Activate purchase code");
//         const k = document.createTextNode("Step 3: Install theme");
//         const w = document.createTextNode("Go to 'Blueskytecho' > 'License' to active your purchase code.");
//         const x = document.createTextNode("Go to 'Blueskytecho' > 'Install theme' and install your favorite home.");
//         const m = document.createTextNode("👉 Get Umino purchase code");
//         const step1 = document.createElement("DIV");
//         const step2 = document.createElement("DIV");
//         const step3 = document.createElement("DIV");
//         pca.setAttribute("target", "_blank");
//         pca.setAttribute("href", "https://themeforest.net/user/blueskytechco");
//         step1.setAttribute("class", "step-1");
//         step2.setAttribute("class", "step-2");
//         step3.setAttribute("class", "step-3");
//         pca.appendChild(m);
//         step2p.appendChild(w);
//         step3p.appendChild(x);
//         b.appendChild(t);
//         c.appendChild(s);
//         d.appendChild(q);
//         e.appendChild(p);
//         f.appendChild(k);
//         step1.appendChild(d);
//         step2.appendChild(e);
//         step2.appendChild(step2p);
//         step2.appendChild(pca);
//         step3.appendChild(f);
//         step3.appendChild(step3p);
//         a.setAttribute("id", "bls__not-active");
//         n.appendChild(b);
//         n.appendChild(c);
//         n.appendChild(step1);
//         n.appendChild(step2);
//         n.appendChild(step3);
//         a.appendChild(n);
//         document.querySelector('body').appendChild(a);
//       }else{
//         $('#'+"bls__"+shop).remove();
//       };
//     }
//   }
// })();
// setTimeout(() => {
//   Blscpc.init();
// }, 1500);